import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { createUserAsync } from "settings/actions/users";
import UserForm from "settings/components/UserForm";
import { initialState } from "settings/reducers/users";

class NewUser extends React.Component {
  render() {
    return (
      <UserForm
        fields={[
          { slug: "first_name", name: "First name", required: true },
          { slug: "last_name", name: "Last name", required: true },
          { slug: "display_name", name: "Byline" },
          { slug: "job_title", name: "Job title" },
          { slug: "email", name: "Email", required: true },
          { slug: "username", name: "Username", required: true },
        ]}
        titleText="Create a new user"
        successText="New user created"
        submitText="Create user"
        user={{ ...initialState.profile }}
        save={(...props) =>
          this.props
            .createUserAsync(...props)
            .then(() => this.props.history.push("/settings/users"))
        }
        showCancel={true}
        showPermissions={true}
        showPhoto={false}
        allowDisable={false}
      />
    );
  }
}

NewUser.propTypes = {
  createUserAsync: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default connect(
  () => ({}),
  {
    createUserAsync,
  }
)(NewUser);
